"use client";

import { datadogRum } from "@datadog/browser-rum";
import { useBoundStore } from "@frontend/lib/stores/globalStore";
import { Button } from "@frontend/shared/components/ui/button";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";

const ErrorPage = ({
  error,
  reset,
  redirectUrl,
  redirectText,
  showImage,
  showSupport,
}: {
  error: Error & { digest?: string };
  reset: () => void;
  redirectUrl: string;
  redirectText: string;
  showImage: boolean;
  showSupport: boolean;
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const resetAllStores = useBoundStore.use.resetAllStores();

  useEffect(() => {
    const sessionId = datadogRum.getInternalContext()?.session_id;
    datadogRum.addError(error, {
      pathname,
      digest: error.digest,
      session_id: sessionId,
    });

    resetAllStores();
  }, [error, pathname, resetAllStores]);

  return (
    <div className="h-dvh flex flex-col justify-center items-center text-center gap-4 p-4">
      {showImage && (
        <Image
          src="https://rsup2.b-cdn.net/spec.png"
          alt="spec"
          width={200}
          height={400}
        />
      )}
      <h2>Something went wrong!</h2>
      <Button
        onClick={() => {
          if (redirectUrl === pathname) {
            reset();
          } else {
            router.push(redirectUrl);
          }
        }}
      >
        {redirectText}
      </Button>
      {showSupport && (
        <p>
          If this error persists, please contact us at support@superscript.nyc
        </p>
      )}
    </div>
  );
};

export default ErrorPage;
